<template>
  <div
    v-if="account"
    key="account"
    class="flex-1 h-0"
    :class="{ 'overflow-hidden': isTransitioning }"
  >
    <TransitionPage @begin="isTransitioning = true" @end="isTransitioning = false">
      <RouterView />
    </TransitionPage>
  </div>
</template>

<script>
import store from '@/store';
import { accountMethods, accountComputed, authComputed } from '@/store/helper';
import TransitionPage from '@/components/TransitionPage.vue';

export default {
  name: 'AccountSingle',
  components: {
    TransitionPage,
  },
  data: () => ({
    isTransitioning: false,
  }),
  props: {
    accountId: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...accountComputed,
    ...authComputed,
  },
  created() {
    this.setCurrent(this.accountId);
  },
  destroyed() {
    this.setCurrent(null);
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const { accountId } = to.params;
      await store.dispatch('ui/accounts/switchAccount', { accountId });
      next();
    } catch (error) {
      next(false);
    }
  },
  async beforeRouteUpdate(to, from, next) {
    try {
      const { accountId } = to.params;
      if (to.params.accountId === from.params.accountId) {
        return next();
      }

      await store.dispatch('ui/accounts/switchAccount', { accountId });
      return next();
    } catch (error) {
      return next(false);
    }
  },
  methods: {
    ...accountMethods,
    onSearchChange() {},
  },
};
</script>
